import { dashboardProfileOptions, dashboardProfilesOptions } from "@dashboard/api/queryApi";
import { useSidebarRefresh } from "@/features/hub/sidebarRefreshContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import type { DashboardProfile } from "@dashboard/utils/dashboard.types";

export function useDashboardProfilesQuery(productInstanceId: number, initialProfileName: string) {
    const queryClient = useQueryClient();
    const sidebarRefresh = useSidebarRefresh();
    const getInitialProfileName = useCallback(() => initialProfileName, [initialProfileName]);
    const handleProfileCreated = useCallback(
        (profile: DashboardProfile) => {
            queryClient.setQueryData(
                dashboardProfileOptions(productInstanceId, profile.id).queryKey,
                profile,
            );
            void sidebarRefresh?.refreshSidebar();
        },
        [productInstanceId, queryClient, sidebarRefresh],
    );

    return useQuery(
        dashboardProfilesOptions(productInstanceId, getInitialProfileName, handleProfileCreated),
    );
}
